<template>
  <div>
    <Button
      :size="15"
      color="#2c7bcd"
      colorText="#ffffff"
      tooltip="Generar acuerdo clientes"
      icon="icon fa fa-window-restore"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      translate
      :inactive="data.length === 0"
      @click.native="data.length > 0 ? openModal('modal') : ''"
    />

    <ui-modal
      ref="modal"
      title="Generar Acuerdo de Cliente Base según Filtros"
      @close="ActionSetZindexTablaModal(false)"
      size="large">

      <div v-if="data.length > 0">

        <h5 class="fw-bold mb-3">Se han seleccionado {{ data.length }} acuerdos de líneas</h5>

        <p class="mt-4 mb-4">Para poder generar los "Acuerdos Cliente" seleccion el (los) cliente(s) añada un margen y
          posterior a esto, por favor, presione el botón "Generar"</p>

        <div class="col-lg-12" style="height: 350px;">
          <div class="w-100">
            <div style="color: grey; font-size: 15px;">Cliente(s)</div>
            <multiselect
              placeholder="Seleccionar"
              :options="clients"
              :searchable="true"
              v-model="selected_clients"
              :multiple="true"
              label="name"
              track-by="name"
              :limit="1"
              :limitText=" count => `+ ${count} registros` "
              selectLabel="Agregar"
              deselectLabel="Quitar"
              selectedLabel="Agregado"
              :close-on-select="false">
              <template slot="beforeList">
                <div class="d-flex align-items-center ml-2 selectAll">
                  <input id="checkAllClients" ref="checkAllClients" type="checkbox"
                         @change="selectAllClients($event, clients);">
                  <label class="mt-2 ml-2" style="width: 100%" for="checkAllClients">Seleccionar todo</label>
                </div>
              </template>
            </multiselect>
          </div>
          <div class="w-100 mt-4">
            <label>Margen</label>
            <ui-textbox
              type="text"
              style="font-size: 8px !important"
              class="mt-1"
              v-model="selected_margin"
              v-mask="weightMask"
            >
            </ui-textbox>
          </div>
          <div class="w-100 mt-4">
            <label>Vigencia</label>
            <date-picker
              class="w-100 mt-3"
              type="date"
              placeholder="Vigencia"
              @close="handleOpenChange"
              value-type="format"
              v-model="selected_validity"
            />
          </div>
          <div class="d-flex justify-content-between mt-5">
            <button class="btn btn-default" @click="closeModal('modal')">
              Cerrar
            </button>
            <div style="float: right">
              <button
                :disabled="!enabledBtn"
                class="btn btn-outline-primary"
                id="buttonRef"
                @click="generate()">
                {{ txtBtn }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>

import UiModal from "keen-ui/src/UiModal";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import Button from "../../../../common/Button";
import { mapActions, mapState } from "vuex";
import { generateTariffClients, getAcuerdosClientesBase, getClients } from "@/constants/lineas";
import Vue from "vue";
import Multiselect from "vue-multiselect";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

Vue.component("multiselect", Multiselect);

const weightMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 6,
  allowNegative: true
});

export default {
  props: {
    data: { type: Array, default: () => ([]) },
    clearSelection: { type: Function, default: () => ({}) }
  },
  data() {
    return {
      weightMask,
      index: 0,
      clients: [],
      selected_clients: [],
      selected_margin: 0,
      selected_validity: "",
      txtBtn: "Generar",
      enabledBtn: true,
      showTimePanel: false
    };
  },
  components: {
    UiModal,
    Button,
    DatePicker,
    Multiselect
  },
  computed: {

    ...mapState([]),

    ...mapState("lineas", [])

  },
  methods: {
    ...mapActions("lineas", ["actionSetDataListarTarifasAcuerdosClientesBase"]),

    ...mapActions(["ActionSetZindexTablaModal"]),

    async openModal(ref) {

      await this.ActionSetZindexTablaModal(true);

      this.$refs[ref].open();

    },

    btnStatus(status) {

      if (status) {

        this.enabledBtn = status;

        this.txtBtn = "Generar";

      } else {

        this.enabledBtn = status;

        this.txtBtn = "Generando...";

      }

    },

    resetForm() {

      this.clearSelection();

      this.selected_clients = [];

      this.selected_margin = "";

      this.selected_validity = "";

      this.$refs.checkAllClients.checked = false;

    },

    async fetchClients() {

      const { data } = await getClients();

      this.clients = data;

    },

    handleOpenChange() {

      this.showTimePanel = false;

    },

    selectAllClients(event, options) {

      if (event.target.checked) {

        this.selected_clients = options;

      } else {

        this.selected_clients = "";

      }
    },

    async generate() {

      if (this.data.length === 0) {

        return this.$vToastify.error(
          `Debe seleccionar al menos una tarifa`,
          "Error: Tarifas"
        );

      }

      if (this.selected_clients.length === 0) {

        return this.$vToastify.error(
          `Debe seleccionar al menos un cliente`,
          "Error: Clientes"
        );

      }

      if (this.selected_margin === "") {

        return this.$vToastify.error(
          `Debe ingresar un margen`,
          "Error: Margen"
        );

      }

      if (!this.selected_validity) {

        return this.$vToastify.error(
          `Debe ingresar una fecha de vigencia`,
          "Error: Vigencia"
        );

      }

      //
      this.$vToastify.loader("Generando...");

      this.btnStatus(false);

      try {

        const form = {
          clients: this.selected_clients.map(x => x.id),
          margin: this.selected_margin,
          tariff_lines_ids: this.data.map(x => x.data_complementaria.id_acuerdo),
          validity: this.selected_validity
        };

        const { data, status, message } = await generateTariffClients(form);

        if (!status && data.length === 0) {

          this.$vToastify.stopLoader();

          this.btnStatus(true);

          return this.$vToastify.warning(
            message,
            "¡Alerta!"
          );

        }

        const { data_table } = await getAcuerdosClientesBase();

        await this.actionSetDataListarTarifasAcuerdosClientesBase(data_table);

        this.closeModal("modal");

        this.resetForm();

        this.$vToastify.success(
          `Acuerdo de Clientes generados : ${data.length}`,
          "¡Realizado!"
        );

        this.$vToastify.stopLoader();

        this.btnStatus(true);

      } catch (error) {

        this.$vToastify.stopLoader();

        this.btnStatus(true);

        return this.$vToastify.error(
          `No se pudieron generar acuerdos de clientes según los datos proporcionados.`,
          "Error: Generación de acuerdos de clientes"
        );

      }

    },

    closeModal(ref) {

      this.$refs[ref].close();

    }

  },
  beforeMount() {

    this.fetchClients();

  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}

.selectAll > [type="checkbox"] {
  width: 18px;
  height: 18px;
}

.selectAll :hover {
  cursor: pointer;
}

.multiselect__tags {
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #e8e8e8 !important;
  font-size: 16px !important;
  padding: 4px 40px 0 8px !important;
  min-height: 32px;
}

.multiselect, .multiselect__input, .multiselect__single {
  font-size: 14px;
}

</style>
